import { render, staticRenderFns } from "./in-select2.vue?vue&type=template&id=0d73d3b7"
import script from "./in-select2.vue?vue&type=script&lang=js"
export * from "./in-select2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports